import { createContext } from "react";

const AuthContext = createContext({
    user: null,
    token:null,
    logout: () => { }
});

export default AuthContext;
